import React, { memo } from 'react';
import PropTypes from 'prop-types';
import FlexFullwidthCard from '../Views/FlexFullwidthCard';

const FlexJobCard = memo(({ item, compact, hideLink, gridLayout }) => (
  <FlexFullwidthCard
    item={item}
    compact={compact}
    hideLink={hideLink}
    gridLayout={gridLayout}
  />
));

FlexJobCard.propTypes = {
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
  }).isRequired,
  compact: PropTypes.bool,
  hideLink: PropTypes.bool,
  gridLayout: PropTypes.bool,
};

export default FlexJobCard;
